import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f01d2ce6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "signup-modal__announcement" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "signup-modal__announcement-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "email sent icon",
    src: "/img/icons/email-sent.svg"
  })
], -1))
const _hoisted_3 = { class: "signup-modal__announcement-title" }
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxPanel = _resolveComponent("PxPanel")!

  return (_openBlock(), _createBlock(_component_PxPanel, {
    "no-borders": true,
    class: "signup-modal"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("authentication.signup.success.title")), 1),
        _createElementVNode("div", {
          class: "signup-modal__announcement-message",
          innerHTML: 
          _ctx.$t('authentication.signup.success.message', { registrationEmail: _ctx.registrationEmail })
        
        }, null, 8, _hoisted_4)
      ])
    ]),
    _: 1
  }))
}